import { faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import { ModalCloseButton } from '@nx-fe/components';
import { useTranslation } from 'react-i18next';
import { useIntegrationsStore } from '../store';
import { StyledContent, StyledDialog } from './connect-confirm.styled';

const ConnectConfirm = () => {
  const { t } = useTranslation('integrations');
  const {
    isConnectConfirmOpen,
    cancelConnect,
    confirmConnect,
    connectConfirmTitle,
  } = useIntegrationsStore();

  return (
    <StyledDialog
      open={isConnectConfirmOpen}
      onClose={cancelConnect}
      aria-labelledby="connect-confirm"
      aria-describedby="connect-confirm"
      data-cy="connect-confirm"
    >
      <ModalCloseButton
        data-cy="connect-confirm-close"
        aria-label="close"
        onClick={cancelConnect}
      >
        <FontAwesomeIcon icon={faXmark} />
      </ModalCloseButton>
      <DialogTitle id="alert-dialog-title">
        {t('sharepoint.confirm.title', { title: connectConfirmTitle })}
      </DialogTitle>
      <DialogContent dividers>
        <StyledContent>
          <p>
            {t('sharepoint.confirm.subtitle', { title: connectConfirmTitle })}
          </p>
          <ol>
            <li>
              {t('sharepoint.confirm.desc_1', { title: connectConfirmTitle })}
            </li>
            <li>
              {t('sharepoint.confirm.desc_2', { title: connectConfirmTitle })}
            </li>
          </ol>
          <p>
            {t('sharepoint.confirm.footer', { title: connectConfirmTitle })}
          </p>
        </StyledContent>
      </DialogContent>
      <DialogActions>
        <Button
          data-cy="connect-confirm-cancel"
          onClick={cancelConnect}
          color="tertiary"
          variant="outlined"
        >
          {t('sharepoint.confirm.cancel_btn', { title: connectConfirmTitle })}
        </Button>
        <Button
          data-cy="connect-confirm-btn"
          onClick={confirmConnect}
          color="primary"
          variant="contained"
        >
          {t('sharepoint.confirm.confirm_btn', { title: connectConfirmTitle })}
        </Button>
      </DialogActions>
    </StyledDialog>
  );
};

export default ConnectConfirm;
